<template>
  <div class="txt_pop">
    <div class="txt">
      <h4>{{ $t('message.login.agreement.agreement_title') }}</h4>
      <p>{{ $t('message.login.agreement.one') }}</p>
      <p>
        {{ $t('message.login.agreement.h1n1') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h1n2') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h1n3') }}
      </p>
      <p>{{ $t('message.login.agreement.two') }}</p>
      <p>
        {{ $t('message.login.agreement.h2n1') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h2n2') }}
      </p>
      <p>{{ $t('message.login.agreement.three') }}</p>
      <p>{{ $t('message.login.agreement.h3n1') }}</p>
      <p>
        {{ $t('message.login.agreement.h3n2') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h3n3') }}
      </p>
      <p>{{ $t('message.login.agreement.h3n3s1') }}</p>
      <p>{{ $t('message.login.agreement.h3n3s2') }}</p>
      <p>{{ $t('message.login.agreement.four') }}</p>
      <p>
        {{ $t('message.login.agreement.h4n1') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h4n2') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h4n3') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h4n4') }}
      </p>
      <p>{{ $t('message.login.agreement.h4n4s1') }}</p>
      <p>
        {{ $t('message.login.agreement.h4n4s2') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h4n4s3') }}
      </p>
      <p>{{ $t('message.login.agreement.h4n4s4') }}</p>
      <p>{{ $t('message.login.agreement.h4n5') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s1') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s2') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s3') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s4') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s5') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s6') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s7') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s8') }}</p>
      <p>{{ $t('message.login.agreement.h4n6') }}</p>
      <p>{{ $t('message.login.agreement.h4n7') }}</p>
      <p>{{ $t('message.login.agreement.h4n8') }}</p>
      <p>{{ $t('message.login.agreement.h4n9') }}</p>
      <p>{{ $t('message.login.agreement.h4n10') }}</p>
      <p>{{ $t('message.login.agreement.five') }}</p>
      <p>{{ $t('message.login.agreement.h5n1') }}</p>
      <p>{{ $t('message.login.agreement.h5n2') }}</p>
      <p>{{ $t('message.login.agreement.h5n3') }}</p>
      <p>{{ $t('message.login.agreement.h5n4') }}</p>
      <p>{{ $t('message.login.agreement.six') }}</p>
      <p>{{ $t('message.login.agreement.h6n1') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s1') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s2') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s3') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s4') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s5') }}</p>
      <p>{{ $t('message.login.agreement.h6n2') }}</p>
      <p>{{ $t('message.login.agreement.h6n3') }}</p>
      <p>{{ $t('message.login.agreement.h6n4') }}</p>
      <p>{{ $t('message.login.agreement.seven') }}</p>
      <p>{{ $t('message.login.agreement.h7n1') }}</p>
      <p>{{ $t('message.login.agreement.h7n2') }}</p>
      <p>{{ $t('message.login.agreement.h7n3') }}</p>
      <p>{{ $t('message.login.agreement.h7n4') }}</p>
      <p>{{ $t('message.login.agreement.h7n5') }}</p>
      <p>{{ $t('message.login.agreement.h7n5s1') }}</p>
      <p>{{ $t('message.login.agreement.h7n5s2') }}</p>
      <p>{{ $t('message.login.agreement.eight') }}</p>
      <p>{{ $t('message.login.agreement.h8n1') }}</p>
      <p>{{ $t('message.login.agreement.h8n2') }}</p>
      <p>{{ $t('message.login.agreement.h8n2s1') }}</p>
      <p>{{ $t('message.login.agreement.h8n2s2') }}</p>
      <p>{{ $t('message.login.agreement.nine') }}</p>
      <p>{{ $t('message.login.agreement.h9n1') }}</p>
      <p>{{ $t('message.login.agreement.h9n2') }}</p>

      <p>{{ $t('message.login.agreement.ten') }}</p>
      <p>{{ $t('message.login.agreement.h10n1') }}</p>
      <p>{{ $t('message.login.agreement.h10n2') }}</p>

      <p>{{ $t('message.login.agreement.eleven') }}</p>
      <p>{{ $t('message.login.agreement.h11n1') }}</p>
      <p>{{ $t('message.login.agreement.h11n2') }}</p>
      <p>{{ $t('message.login.agreement.twelve') }}</p>
      <p>{{ $t('message.login.agreement.h12n1') }}</p>
      <p>{{ $t('message.login.agreement.h12n2') }}</p>
      <p>{{ $t('message.login.agreement.h12n3') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserTextPop'
}
</script>

<style lang="less" scoped>
.txt_pop {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 32px;

  h4 {
    text-align: center;
    font-size: 18px;
    color: #1a1a1a;
    font-weight: 500;
  }

  p {
    margin: 10px 0;
    font-size: 14px;
    color: #1a1a1a;
  }
}
</style>
